/* ================================================================
   LA BARRA DEL MENU SE ESCONDE AL BAJAR Y VUELVE AL SUBIR

   Traido del tema de Fiestas Patrias 2026, donde iba dentro de
   fiestas-patrias.js y se apagaba junto con la campana. Aca es una
   funcion permanente del sitio, en su propio archivo.

   Los estilos que lo acompanan estan en el bloque 47 de custom.css.

   Para apagarlo: comentar la linea que lo carga en layout/theme.liquid.
   Sin el script, la clase `np-nav-oculta` nunca se pone y el CSS queda
   inerte: el header vuelve a comportarse como siempre.
   ================================================================ */
(function () {
  'use strict';

  // GUARDIA. `sections/pagina-nosotros.liquid` trae esta misma logica
  // embebida, atada a su ajuste "Barra del menu", y en la pagina
  // Conocenos correrian las dos a la vez. Hacen lo mismo y no se
  // estorban, pero sobra una: la primera que arranca se queda con el
  // trabajo y la otra se retira. El script de la seccion es inline y
  // corre antes que este, que va con `defer`.
  if (window.__npNavAutohide) return;
  window.__npNavAutohide = true;

  // Se busca sin `.sticky-header` a proposito: esa clase la agrega
  // theme.js al arrancar y no viene en el HTML del servidor.
  var header = document.querySelector('.shopify-section.header-section');
  if (!header) return;

  var cuerpo = document.body;
  var ultimo = window.pageYOffset || 0;
  var pendiente = false;

  // Movimientos mas chicos que esto no cuentan: sin el umbral, el temblor
  // del dedo en el telefono hace parpadear la barra. `ultimo` NO se
  // actualiza en ese caso, asi que los micromovimientos se van sumando
  // hasta superarlo en vez de perderse.
  var MINIMO = 6;
  // Arriba del todo la barra se ve siempre, aunque el gesto sea hacia abajo.
  var DESDE = 120;

  function evaluar() {
    pendiente = false;
    var y = window.pageYOffset || 0;
    if (y < 0) y = 0;              // rebote elastico de iOS
    var d = y - ultimo;
    if (Math.abs(d) < MINIMO) return;

    // Con un cajon abierto -carrito, menu, buscador- no se toca: el scroll
    // de fondo esta bloqueado y esconder la barra dejaria su boton de
    // cerrar fuera de alcance.
    if (cuerpo.classList.contains('js-drawer-open')) { ultimo = y; return; }

    if (y <= DESDE) cuerpo.classList.remove('np-nav-oculta');
    else if (d > 0) cuerpo.classList.add('np-nav-oculta');
    else cuerpo.classList.remove('np-nav-oculta');

    ultimo = y;
  }

  // `passive` para no trabar el scroll, y una sola evaluacion por cuadro:
  // el evento se dispara decenas de veces por segundo y no hace falta
  // mirar mas seguido de lo que el navegador dibuja.
  window.addEventListener('scroll', function () {
    if (pendiente) return;
    pendiente = true;
    window.requestAnimationFrame(evaluar);
  }, { passive: true });
})();
